import { gql } from "@apollo/client";

export const GET_MANY_USER_ADDRESS_FACEBOOK_ID = gql`
  query UserAddressFacebookId($where: UserAddressWhereInput) {
    userAddressFacebookId(where: $where) {
      total
      data {
        id
        user
        facebookId
        deliveryName
        userName
        userTel
        province
        district
        village
        branch
        labelAs
        codNumber
        default
        latLong
        location
        isOpen
        address
        receive_branch_id
        createdAt
        updatedAt
        img
        branchCode
      }
    }
  }
`;

export const GET_MANY_USER_ADDRESS_USER_ID = gql`
  query UserAddressUserId($where: UserAddressWhereInput) {
    userAddressUserId(where: $where) {
      total
      data {
        id
        user
        facebookId
        deliveryName
        userName
        userTel
        province
        district
        village
        branch
        labelAs
        codNumber
        default
        latLong
        location
        isOpen
        address
        receive_branch_id
        createdAt
        updatedAt
        img
        branchCode
      }
    }
  }
`;